import React, { useEffect } from 'react';

import PrismIcon from '../prism/icon/prismIcon';
import PrismLink from '../prism/link/prismLink';
import PrismMessage from '../prism/message/prismMessage';
import PrismButton from '../prism/button/prismButton';

function TermsAndConditions({ invalidDealers = [], tcContentUrl, onDeclineClick, onAcceptClick }) {
    useEffect(() => {
        const url = new URL(tcContentUrl);

        const aemEnv = `${url.protocol}//${url.hostname}`;

        (function (i, s, o, g, r, a, m) {
            i['ManheimAEMObject'] = r;
            (i[r] =
                i[r] ||
                function () {
                    (i[r].q = i[r].q || []).push(arguments);
                }),
                (i[r].l = i[r].l || 1 * new Date());
            (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
            a.async = 1;
            a.src = g + '?l=' + i[r].l;
            m.parentNode.insertBefore(a, m);
        })(
            window,
            document,
            'script',
            aemEnv + '/etc/clientlibs/framework/shared/js/widgets.js',
            'aem_wdg'
        );

        aem_wdg('', 'manheim-terms-and-conditions', 'manheim-terms-and-conditions__content', []);
    }, []);

    const invalidDealersList = invalidDealers.map(({ accountNumber, dealerName }) => {
        return (
            <div key={accountNumber} className="manheim-terms-and-conditions__account-container">
                <div className="manheim-terms-and-conditions__account-number">{accountNumber}</div>
                <div className="manheim-terms-and-conditions__account-description">
                    {dealerName}
                </div>
            </div>
        );
    });

    return (
        <div className="manheim-terms-and-conditions">
            <div className="manheim-terms-and-conditions__content-container">
                <div className="manheim-terms-and-conditions__print-container">
                    <PrismLink
                        linkClassName="manheim-terms-and-conditions__print-link"
                        onClick={() => {
                            window.print();
                        }}
                    >
                        <PrismIcon
                            className="manheim-terms-and-conditions__print-icon"
                            glyph="printer"
                        />
                        &nbsp;Print
                    </PrismLink>
                </div>
                <PrismMessage
                    className="manheim-terms-and-conditions__message-container"
                    color="warning"
                    title="You must accept the terms and conditions for these dealerships to continue."
                >
                    {invalidDealersList}
                </PrismMessage>
                <div
                    className="manheim-terms-and-conditions__content"
                    id="manheim-terms-and-conditions__content"
                ></div>
            </div>
            <div className="manheim-terms-and-conditions__buttons-container">
                <div className="manheim-terms-and-conditions__buttons">
                    <PrismButton
                        type="button"
                        textonly
                        className="manheim-terms-and-conditions__footer-button"
                        buttonClassName="manheim-terms-and-conditions__link-button"
                        title="Go to top"
                        onClick={() => {
                            window.scrollTo(0, 0);
                        }}
                    >
                        TOP
                    </PrismButton>
                    <div>
                        <PrismButton
                            className="manheim-terms-and-conditions__footer-button manheim-terms-and-conditions__accept-button"
                            onClick={onAcceptClick}
                        >
                            ACCEPT
                        </PrismButton>
                        <PrismButton
                            type="button"
                            textonly
                            className="manheim-terms-and-conditions__footer-button"
                            buttonClassName="manheim-terms-and-conditions__link-button"
                            onClick={onDeclineClick}
                        >
                            DECLINE
                        </PrismButton>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TermsAndConditions;
